import { Footer as BronsonReactFooter } from "@vwfs-bronson/bronson-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const Footer: React.FunctionComponent = () => {
    const { t } = useTranslation("footer");
    return (
        <>
            <BronsonReactFooter>
                <BronsonReactFooter.ModuleMetaNav metaSectionLabel="Legal and Privacy" copyrightText={`${t("copyright")} ${new Date().getFullYear()}`} >

                    <BronsonReactFooter.ModuleMetaNav.Item
                        href={t("links.corporate")}
                        normalLink={true}
                        linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
                        aria-label={t("aria-labels.corporate")}
                    >
                        {t("corporate")}
                    </BronsonReactFooter.ModuleMetaNav.Item>

                    <BronsonReactFooter.ModuleMetaNav.Item
                        href={t("links.cookie-policy")}
                        normalLink={true}
                        linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
                        aria-label={t("aria-labels.cookie-policy")}
                    >
                        {t("cookie-policy")}
                    </BronsonReactFooter.ModuleMetaNav.Item>

                    <BronsonReactFooter.ModuleMetaNav.Item
                        href={t("links.privacy-policy")}
                        normalLink={true}
                        linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
                        aria-label={t("aria-labels.privacy-policy")}
                    >
                        {t("privacy-policy")}
                    </BronsonReactFooter.ModuleMetaNav.Item>

                    <BronsonReactFooter.ModuleMetaNav.Item
                        href={t("links.informative-privacy")}
                        normalLink={true}
                        linkProps={{ target: "_blank", rel: "noopener noreferrer" }}
                        aria-label={t("aria-labels.informative-privacy")}
                    >
                        {t("informative-privacy")}
                    </BronsonReactFooter.ModuleMetaNav.Item>
                </BronsonReactFooter.ModuleMetaNav>
                <BronsonReactFooter.ModuleFootnotes footerText={`${t("copyright-text")}`} />
            </BronsonReactFooter>
        </>
    );
};

export default Footer;
